import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "intouch-course-cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }, [items]);

  const value = useMemo(() => ({
    items,
    count: items.length,
    add(course) {
      if (!course?.slug || course.is_sold_out) return false;
      setItems((current) => current.some((item) => item.slug === course.slug) ? current : [...current, {
        id: course.id, slug: course.slug, title: course.title, thumbnail: course.thumbnail,
        price_kurus: course.price_kurus || 0, currency: course.currency || "TRY",
        delivery_mode: course.delivery_mode || "online", venue: course.venue || null,
        start_at: course.start_at || null,
      }]);
      return true;
    },
    remove(slug) { setItems((current) => current.filter((item) => item.slug !== slug)); },
    clear() { setItems([]); },
    has(slug) { return items.some((item) => item.slug === slug); },
  }), [items]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) throw new Error("useCart must be used inside CartProvider");
  return context;
}
